enum ETokens {
	'USDT' = 'USDT',
	'ACT' = 'ACT',
}

export default ETokens;
